import { DEFAULT_LOCALE, isSupportedLocale, isUnlocalizedPath } from '@/i18n/config';

/**
 * Given a raw pathname (e.g. from window.location.pathname), strip a locale
 * prefix if present and return both the detected locale and the underlying
 * unprefixed path. "/de/pro" -> { locale: 'de', path: '/pro' }.
 * "/pro" -> { locale: 'en', path: '/pro' }.
 */
export function stripLocalePrefix(pathname: string): { locale: string; path: string } {
  const segments = pathname.split('/');
  const maybeLocale = segments[1];

  if (isSupportedLocale(maybeLocale) && maybeLocale !== DEFAULT_LOCALE) {
    const rest = `/${segments.slice(2).join('/')}`;
    return { locale: maybeLocale, path: rest === '/' ? '/' : rest.replace(/\/$/, '') || '/' };
  }

  return { locale: DEFAULT_LOCALE, path: pathname || '/' };
}

/**
 * Given an unprefixed marketing path (e.g. "/pro") and a target locale,
 * return the URL for that locale. English has no prefix. The blog is never
 * locale-prefixed (it stays English-only), so it's returned unchanged
 * regardless of the requested locale.
 */
export function localizedPath(path: string, locale: string): string {
  if (isUnlocalizedPath(path)) {
    return path;
  }
  if (locale === DEFAULT_LOCALE) {
    return path;
  }
  return path === '/' ? `/${locale}` : `/${locale}${path}`;
}
